import type { WsTask } from '../types'

// ==========================================================
// Mock data para desenvolvimento
// Será substituído por fetch do Supabase quando integrado
// ==========================================================

export const MOCK_TASKS: WsTask[] = [
  {
    id: 'task-0',
    title: 'Passaporte de Contexto',
    description: 'Gere seu Passaporte de Contexto usando IA. Forneça informações sobre o expert (transcrição, texto, PDF) e receba um documento completo de posicionamento estratégico com segmentos de mercado, personas e mapa de oportunidades.',
    layer_id: 'layer-fundacao',
    status: 'todo',
    bloom_level: 'create',
    cs_score: 1,
    xp_reward: 250,
    estimated_minutes: 15,
    position: 0,
    blocked_by: [],
    redirect_url: '/passo1',
    started_at: null,
    completed_at: null,
    last_moved_at: null,
    created_at: new Date().toISOString(),
  },
  {
    id: 'task-1',
    title: 'Entrevista Estruturada',
    description: 'Extraia o conhecimento tácito do expert usando técnicas de elicitação (Polanyi + Klein). O resultado é uma transcrição organizada que revela padrões, histórias e métodos que o expert usa intuitivamente.',
    layer_id: 'layer-fundacao',
    status: 'todo',
    bloom_level: 'understand',
    cs_score: 1,
    xp_reward: 100,
    estimated_minutes: 60,
    position: 1,
    blocked_by: [],
    started_at: null,
    completed_at: null,
    last_moved_at: null,
    created_at: new Date().toISOString(),
  },
  {
    id: 'task-2',
    title: 'Segmentos de Mercado',
    description: 'Mapeie os segmentos de mercado do expert usando a Teoria de Valores de Schwartz. Identifique quais valores motivam cada segmento e qual tem maior potencial de conversão.',
    layer_id: 'layer-fundacao',
    status: 'todo',
    bloom_level: 'analyze',
    cs_score: 1,
    xp_reward: 100,
    estimated_minutes: 45,
    position: 2,
    blocked_by: [],
    started_at: null,
    completed_at: null,
    last_moved_at: null,
    created_at: new Date().toISOString(),
  },
  {
    id: 'task-3',
    title: 'Persona Dissecada',
    description: 'Construa a persona do aluno ideal usando princípios de Andragogia (Knowles). Vá além de dados demográficos - mapeie motivações, barreiras, experiência prévia e estilo de aprendizagem.',
    layer_id: 'layer-fundacao',
    status: 'todo',
    bloom_level: 'create',
    cs_score: 1,
    xp_reward: 150,
    estimated_minutes: 90,
    position: 3,
    blocked_by: [],
    started_at: null,
    completed_at: null,
    last_moved_at: null,
    created_at: new Date().toISOString(),
  },
  {
    id: 'task-4',
    title: 'Síntese Final do Contexto',
    description: 'Revise e consolide os documentos gerados (Passaporte, Entrevista, Segmentos, Persona) em uma narrativa coesa. Valide convergências, resolva contradições e garanta que a base está sólida para as próximas camadas.',
    layer_id: 'layer-fundacao',
    status: 'todo',
    bloom_level: 'evaluate',
    cs_score: 1,
    xp_reward: 200,
    estimated_minutes: 60,
    position: 4,
    blocked_by: ['task-0', 'task-1', 'task-2', 'task-3'],
    started_at: null,
    completed_at: null,
    last_moved_at: null,
    created_at: new Date().toISOString(),
  },
  {
    id: 'task-5',
    title: 'Mapa de Contexto',
    description: 'Documento final da Camada Fundação. O Mapa de Contexto é um diagrama visual que conecta expert, mercado e aluno em um framework único. É a bússola do produto educacional.',
    layer_id: 'layer-fundacao',
    status: 'todo',
    bloom_level: 'create',
    cs_score: 1,
    xp_reward: 250,
    estimated_minutes: 45,
    position: 5,
    blocked_by: ['task-4'],
    started_at: null,
    completed_at: null,
    last_moved_at: null,
    created_at: new Date().toISOString(),
  },
]

export const MOCK_SUBTASKS: Record<string, { text: string; done: boolean }[]> = {
  'task-1': [
    { text: 'Preparar roteiro de perguntas de elicitação', done: false },
    { text: 'Conduzir entrevista com o expert (30-60 min)', done: false },
    { text: 'Transcrever e revisar respostas-chave', done: false },
    { text: 'Identificar conhecimento tácito vs explícito', done: false },
    { text: 'Gerar documento de Entrevista Estruturada', done: false },
  ],
  'task-2': [
    { text: 'Listar possíveis segmentos de mercado do expert', done: false },
    { text: 'Aplicar Teoria de Valores de Schwartz a cada segmento', done: false },
    { text: 'Priorizar os 3 segmentos mais alinhados', done: false },
    { text: 'Descrever dores e desejos por segmento', done: false },
    { text: 'Gerar documento de Segmentos de Mercado', done: false },
  ],
  'task-3': [
    { text: 'Definir dados demográficos do aluno ideal', done: false },
    { text: 'Mapear motivações usando princípios de Andragogia', done: false },
    { text: 'Identificar barreiras de aprendizagem do público', done: false },
    { text: 'Descrever o "dia na vida" da persona', done: false },
    { text: 'Definir a transformação desejada (antes/depois)', done: false },
    { text: 'Gerar documento de Persona Dissecada', done: false },
  ],
  'task-4': [
    { text: 'Revisar documento da Entrevista Estruturada', done: false },
    { text: 'Revisar documento de Segmentos de Mercado', done: false },
    { text: 'Revisar documento de Persona Dissecada', done: false },
    { text: 'Cruzar insights e identificar padrões', done: false },
    { text: 'Sintetizar em narrativa única de contexto', done: false },
    { text: 'Gerar documento Passaporte de Contexto', done: false },
  ],
  'task-5': [
    { text: 'Importar dados do Passaporte de Contexto', done: false },
    { text: 'Criar diagrama visual: Expert - Mercado - Aluno', done: false },
    { text: 'Validar conexões e dependências no mapa', done: false },
    { text: 'Adicionar legenda e referências cruzadas', done: false },
    { text: 'Gerar documento final do Mapa de Contexto', done: false },
  ],
}

// Gagné content per task (for full task page)
export const MOCK_GAGNE_CONTENT: Record<string, {
  whyItMatters: string
  outcome: string
  priorKnowledge: string[]
  videoUrl?: string
  videoDuration?: string
  practicePrompt?: string
  verificationHint: string
}> = {
  'task-1': {
    whyItMatters: 'O conhecimento mais valioso de um expert é o que ele não consegue articular espontaneamente. Técnicas de elicitação (Polanyi) permitem extrair padrões, heurísticas e histórias que transformam a experiência tácita em conteúdo estruturado.',
    outcome: 'Um documento completo com os padrões, histórias e métodos do expert organizados por tema, pronto para ser usado na construção do produto educacional.',
    priorKnowledge: [],
    videoDuration: '12:45',
    practicePrompt: 'Grave uma entrevista de 30 minutos com o expert usando o roteiro fornecido. Foque nas perguntas "Como você faz X?" e "Me conta uma história de quando Y aconteceu".',
    verificationHint: 'Upload da transcrição da entrevista com pelo menos 5 insights marcados',
  },
  'task-2': {
    whyItMatters: 'Não existe produto educacional para "todo mundo". A Teoria de Valores de Schwartz revela que pessoas tomam decisões baseadas em valores profundos, não em demografia. Mapear segmentos por valores permite criar mensagens que ressoam.',
    outcome: 'Um mapa de 3-5 segmentos priorizados com valores dominantes, dores e desejos específicos de cada grupo.',
    priorKnowledge: ['Entrevista Estruturada'],
    videoDuration: '10:30',
    practicePrompt: 'Liste 5 possíveis segmentos para o expert. Para cada um, identifique: valor dominante (Schwartz), dor principal, desejo principal, tamanho estimado.',
    verificationHint: 'Documento com pelo menos 3 segmentos mapeados com valores de Schwartz',
  },
  'task-3': {
    whyItMatters: 'Adultos aprendem de forma diferente de crianças (Knowles). Eles precisam de relevância imediata, autonomia e conexão com experiência prévia. Uma persona bem dissecada garante que o produto fale a língua do aluno.',
    outcome: 'Um perfil detalhado do aluno ideal incluindo motivações intrínsecas, barreiras de aprendizagem, nível de experiência e preferências de modalidade.',
    priorKnowledge: ['Segmentos de Mercado'],
    videoDuration: '15:20',
    practicePrompt: 'Construa a persona usando o template fornecido. Inclua: dados demográficos, motivações (Knowles), barreiras, "dia na vida" e transformação desejada.',
    verificationHint: 'Documento de persona com seção de motivações baseada em Andragogia',
  },
  'task-4': {
    whyItMatters: 'Os 3 documentos anteriores são peças de um quebra-cabeça. O Passaporte de Contexto é a imagem completa. Sem ele, as decisões de produto ficam fragmentadas e o expert perde o fio condutor.',
    outcome: 'Um documento consolidado que serve como referência única para todas as decisões de produto. Quem é o expert, quem é o aluno, qual é o mercado.',
    priorKnowledge: ['Entrevista Estruturada', 'Segmentos de Mercado', 'Persona Dissecada'],
    videoDuration: '08:15',
    practicePrompt: 'Abra os 3 documentos anteriores lado a lado. Identifique convergências e contradições. Redija o Passaporte em narrativa contínua (máximo 2 páginas).',
    verificationHint: 'Passaporte de Contexto com referências cruzadas aos 3 documentos anteriores',
  },
  'task-5': {
    whyItMatters: 'O Mapa de Contexto é a bússola visual do produto. Ele mostra em um diagrama como expert, mercado e aluno se conectam. É o documento que o expert consulta antes de qualquer decisão de conteúdo ou marketing.',
    outcome: 'Um diagrama visual que conecta os 3 nós (expert, mercado, aluno) com fluxos de valor entre eles e oportunidades identificadas.',
    priorKnowledge: ['Passaporte de Contexto'],
    videoDuration: '11:00',
    practicePrompt: 'Crie um diagrama com 3 nós centrais (Expert, Mercado, Aluno). Conecte-os com setas nomeadas que representam fluxos de valor. Identifique pelo menos 2 oportunidades.',
    verificationHint: 'Diagrama visual exportado como imagem com legenda',
  },
}
